import React from 'react';

export default function GeneralTab() {
    return <div>General Tab</div>;
}
